import createAssignToUserSelectionDropdown from "app/pages/sales-intelligence/sub-modules/assign-to-users/models/selection-dropdown/factory";
import { LEADS_ASSIGN_SELECTION_TOP_N_VALUES } from "app/pages/sales-intelligence/sub-modules/company-search/constants/websites-table";
import { LeadsType } from "app/pages/sales-intelligence/sub-modules/company-search/types/common";
import type SelectionDropdown from "app/pages/sales-intelligence/sub-modules/table-actions-panel/models/selection-dropdown/SelectionDropdown";

const assignToUserSelectionDropdown: SelectionDropdown = createAssignToUserSelectionDropdown(
    {
        topNValues: LEADS_ASSIGN_SELECTION_TOP_N_VALUES,
    },
    LeadsType.Websites,
);

export default assignToUserSelectionDropdown;
